
document.addEventListener("DOMContentLoaded", function() {
  // Currency selector dropdown
  const currencySelector = document.querySelectorAll('.currency-item a');

  function formatMoney(cents, currencyCode) {
    const amount = cents / 100;
    return new Intl.NumberFormat(navigator.language, {
      style: 'currency',
      currency: currencyCode
    }).format(amount);
  }

  currencySelector.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const newCurrency = this.dataset.value;
      document.querySelector('#currencyCode').value = newCurrency;

      const form = document.getElementById('localization-currency');
      if (form) form.submit();

      const prices = document.querySelectorAll('[data-price]');
      prices.forEach(priceEl => {
        const baseCents = parseInt(priceEl.dataset.price, 10);
        const formatted = formatMoney(baseCents, newCurrency);
        priceEl.textContent = formatted;
      });
    });
  });


  // Language Selector
    document.querySelectorAll('.language-select').forEach(function(el) {
      el.addEventListener('click', function (e) {
      e.preventDefault();

      const langCode = this.dataset.value;
      const form = document.getElementById('localization-language');
      const localeInput = document.getElementById('localeCode');

      if (!form || !localeInput) return;

      localeInput.value = langCode;

      const currentUrl = window.location.pathname + window.location.search;
      let returnInput = form.querySelector('input[name="return_to"]');

      if (!returnInput) {
        returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        form.appendChild(returnInput);
      }

      returnInput.value = currentUrl;

      form.submit();
    });
  });
});